// extracted by mini-css-extract-plugin
module.exports = {"divider":"DashboardPremium_divider__1Oi16","split":"DashboardPremium_split__2kIPR","select":"DashboardPremium_select__2ZFoQ","icon":"DashboardPremium_icon__10TW9"};